app.controller('NotificationController', function(ChatService, $log, $http) {
    this.openChat = ChatService.openChat;

    this.isVisible = () => {
        return !ChatService.isLoading && ChatService.sender && ChatService.sender._id !== this.receiver._id;
    };

    this.readMe = ($event, id, isRead) => {
        if (!isRead) {
            return $http({
                method: 'POST',
                url: '/notifications/read/'+id,
                responseType: 'json'
            }).then(function (httpResponse) {
                if (httpResponse.data) {
                    var unreadCount = jQuery('#unreadCount').text();
                    unreadCount = parseInt(unreadCount);
                    if (unreadCount) {
                        jQuery('.unreadCount').text(unreadCount-1);
                    }
                    var notifyli = angular.element($event.currentTarget).find('.dot');
                    if (notifyli) {
                        notifyli.addClass('read');
                    }
                }
            }).catch(function(httpError) {
                if (httpError.xhrStatus !== "abort") {
                    $log.error(httpError);
                }
                if (httpError.status === 403) {
                    if (loginService.isLoggedIn === false) {
                        loginService.redirectToLoginScreen(true);
                    }
                }
                throw new Error('An error occurred! Please try again later.');
            });
        }
    };
});
